module.exports = __webpack_public_path__ + "static/media/60_WAX.36677225.webp";